<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="zone_header_container">
          <div class="zone_header">
            <h3 class="zone_header_text">
              {{
                truckCount > 1 || truckCount === 0
                  ? $tc("text.assignedTruck.title", 2)
                  : $tc("text.assignedTruck.title", 1)
              }}: {{ truckCount }}
            </h3>
            <img src="@/assets/img/truck (1).png" width="80px" />
          </div>

          <div
            class="zone_input_container"
            style="
              padding-bottom: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <!-- <div class="zone_input_label">
              <label>Truck Name</label>
              <input
                v-model="zone"
                type="text"
                class="zone_input"
              />
            </div> -->
            <div>
              <!-- <button class="create_zone_button" @click="openAddTruckModal">
                ADD TRUCK
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display:none;"
                  width="35px"
                  height="35px"
                  class="ml-3 loader"
                />
              </button> -->
              <div
                style="font-size: 30px; font-weight: 400"
                class="primary_text"
              >
                {{ $tc("text.assignedTruck.title", 1) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row record__expenses">
          <div class="col-md-12 col-lg-12 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="150"
                  field="name"
                  :headerText="$t('text.assignedTruck.truckName')"
                ></e-column>
                <e-column
                  width="240"
                  field="plateNumber"
                  :headerText="$t('text.assignedTruck.plateNumber')"
                ></e-column>
                <e-column
                  width="180"
                  field="tankType"
                  :headerText="$t('text.assignedTruck.tankType')"
                ></e-column>
                <e-column
                  width="180"
                  field="capacity"
                  :headerText="$t('text.assignedTruck.capacity')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <AddTruck></AddTruck>
      <EditTruck :truck="truck"></EditTruck>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import AddTruck from "@/components/modals/Trucks/addTruck.vue";
import EditTruck from "@/components/modals/Trucks/editTruck.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Assigned Trucks  :: Epump Portal",
  name: "Manage Trucks",
  components: {
    MasterLayout,
    AddTruck,
    EditTruck,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      truck: "",
      truckCount: 0,
      company: null,
      backgroundUrl,
      zoneId: null,
      zoneName: "",
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getTrucks();
    }
    this.$eventHub.$on("changeRoute", (route, id) => {
      this.changeRoute(route, id);
    });
    this.$eventHub.$on("setAssigned", (data) => {
      this.truck = data;
    });
    this.$eventHub.$on("getTrucks", () => {
      this.getTrucks();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("changeRoute");
    this.$eventHub.$off("setAssigned");
    this.$eventHub.$off("getTrucks");
  },
  computed: {
    checkNavbarMenu() {
      return this.$store.getters.getMobileNavDrawer;
    },
    // company() {
    //   return this.$store.getters.getCompanyDetails;
    // },
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getTrucks();
      }
    },
  },
  mounted() {},
  methods: {
    changeRoute(route, id) {
      this.$router.push({
        name: route,
        query: {
          id,
        },
      });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    openAddTruckModal() {
      this.$modal.show("addTruck");
    },
    getTrucks() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyTrucks/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          let displayInfo = response.data.filter(
            (cur) => cur.id === this.$route.query.id
          );
          displayInfo.sort((a, b) => {
            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
          });
          displayInfo.forEach((zone, index) => {
            zone.index = index + 1;
          });
          this.showLoader = false;
          this.truckCount = displayInfo.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: displayInfo,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .addTruck .v--modal-box.v--modal {
    /* top: 88px !important; */
    overflow-y: auto;
    margin: 0 auto;
    width: 90% !important;
    height: 500px !important;
    left: 0 !important;
  }
}
</style>
